<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <company-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CompanyCrud from "./CompanyCrud";
    export default {
        name: "CompanyManagementPage",
        components: {CompanyCrud}
    }
</script>

<style scoped>

</style>

